import React from 'react';
import './ShimmerComponents.css';

// Generic shimmer skeleton component with more subtle styling
export const ShimmerBox = ({ width = '100%', height = '20px', borderRadius = '4px', className = '', style = {} }) => (
  <div 
    className={`shimmer-box ${className}`}
    style={{ 
      width, 
      height, 
      borderRadius,
      ...style
    }}
  />
);

// Shimmer for property info section - matches new side-by-side layout
export const PropertyInfoShimmer = () => (
  <div className="property-section-wrapper" style={{ position: 'relative', marginBottom: '32px' }}>
    
    <div className="property-tab-layout">
      {/* Right Column - Info */}
      <div className="property-info-column">
        
        {/* Report Summary Card Shimmer */}
        <div className="market-data-card real-data property-summary-card" style={{ height: '100%' }}>
          <div className="market-data-header">
            <h3 className="market-data-title"><i className="fi fi-rr-file-invoice"></i> ריכוז נתונים</h3>
            <ShimmerBox width="110px" height="14px" />
          </div>
          <div className="market-data-content">
            {/* Summary Text */}
            <div className="data-item summary-text-item">
              <ShimmerBox width="92%" height="16px" style={{ marginBottom: '8px' }} />
              <ShimmerBox width="80%" height="16px" />
            </div>

            {/* Divider after summary text */}
            <div style={{ margin: '2px 0', borderBottom: '1px solid var(--border-light)', gridColumn: '1 / -1' }}></div>

            {/* Property identification rows */}
            <div className="data-item">
              <ShimmerBox width="70px" height="14px" style={{ marginBottom: '6px' }} />
              <ShimmerBox width="120px" height="16px" style={{ marginBottom: '6px' }} />
              <ShimmerBox width="240px" height="12px" />
            </div>
            <div className="data-item">
              <ShimmerBox width="70px" height="14px" style={{ marginBottom: '6px' }} />
              <ShimmerBox width="120px" height="16px" style={{ marginBottom: '6px' }} />
              <ShimmerBox width="220px" height="12px" />
            </div>
            <div className="data-item">
              <ShimmerBox width="100px" height="14px" style={{ marginBottom: '6px' }} />
              <ShimmerBox width="180px" height="16px" style={{ marginBottom: '6px' }} />
              <ShimmerBox width="260px" height="12px" />
            </div>
            <div className="data-item">
              <ShimmerBox width="90px" height="14px" style={{ marginBottom: '6px' }} />
              <ShimmerBox width="200px" height="16px" style={{ marginBottom: '6px' }} />
              <ShimmerBox width="280px" height="12px" />
            </div>
          </div>
        </div>

      </div>

      {/* Left Column - Maps */}
      <div className="property-map-column">
        <div className="location-map-container stacked">
          {/* Map Shimmer */}
          <div className="map-section" style={{ height: '300px', padding: '16px' }}>
            <ShimmerBox width="80px" height="20px" style={{ marginBottom: '12px' }} />
            <ShimmerBox width="100%" height="100%" borderRadius="8px" />
          </div>
          {/* Street View Shimmer */}
          <div className="street-view-section" style={{ height: '300px', padding: '16px' }}>
            <ShimmerBox width="100px" height="20px" style={{ marginBottom: '12px' }} />
            <ShimmerBox width="100%" height="100%" borderRadius="8px" />
          </div>
        </div>
      </div>
    </div>

  </div>
);

// Shimmer for table structure (replacing cards)
export const TableShimmer = ({ rowCount = 5 }) => (
  <div className="plans-table-container">
    {/* Search bar shimmer */}
    <div className="plans-table-header" style={{ marginBottom: '16px', display: 'flex' }}>
      <div className="search-wrapper" style={{ width: '100%', maxWidth: '300px' }}>
        <ShimmerBox width="100%" height="40px" borderRadius="20px" />
      </div>
    </div>

    {/* Table wrapper shimmer */}
    <div className="plans-table-wrapper" style={{ background: 'white', border: '1px solid var(--border-light)', borderRadius: '8px', padding: '0', overflow: 'hidden' }}>
      {/* Table Header */}
      <div style={{ display: 'flex', background: 'rgba(69, 123, 157, 0.8)', padding: '12px 16px', gap: '16px' }}>
        <ShimmerBox width="15%" height="20px" style={{ background: 'rgba(255,255,255,0.3)' }} />
        <ShimmerBox width="15%" height="20px" style={{ background: 'rgba(255,255,255,0.3)' }} />
        <ShimmerBox width="15%" height="20px" style={{ background: 'rgba(255,255,255,0.3)' }} />
        <ShimmerBox width="25%" height="20px" style={{ background: 'rgba(255,255,255,0.3)' }} />
        <ShimmerBox width="15%" height="20px" style={{ background: 'rgba(255,255,255,0.3)' }} />
        <ShimmerBox width="15%" height="20px" style={{ background: 'rgba(255,255,255,0.3)' }} />
      </div>

      {/* Table Rows */}
      {Array.from({ length: rowCount }, (_, index) => (
        <div key={index} style={{ display: 'flex', padding: '12px 16px', gap: '16px', borderBottom: '1px solid var(--border-light)', alignItems: 'center' }}>
          <ShimmerBox width="15%" height="14px" />
          <ShimmerBox width="15%" height="14px" />
          <ShimmerBox width="15%" height="14px" />
          <ShimmerBox width="25%" height="14px" />
          <ShimmerBox width="15%" height="14px" />
          <ShimmerBox width="15%" height="14px" />
        </div>
      ))}
    </div>
    
    {/* Footer shimmer */}
    <div style={{ padding: '8px', marginTop: '4px' }}>
       <ShimmerBox width="100px" height="12px" />
    </div>
  </div>
);

// Shimmer for Tel Aviv municipal section
export const TelAvivShimmer = ({ count = 3 }) => (
  <div className="tel-aviv-results-section mb-4">
    <div className="section-header" style={{ padding: '12px 16px', marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <ShimmerBox width="250px" height="24px" />
      <ShimmerBox width="24px" height="24px" borderRadius="50%" />
    </div>
    <div className="collapsible-content">
      <TableShimmer rowCount={count} />
    </div>
  </div>
);

// Shimmer for Priority Plans section
// Shimmer for other municipal sections
export const MunicipalSectionShimmer = ({ count = 3 }) => (
  <div className="other-results-section mb-4">
    <div className="section-header" style={{ padding: '12px 16px', marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <ShimmerBox width="220px" height="24px" />
      <ShimmerBox width="24px" height="24px" borderRadius="50%" />
    </div>
    <div className="collapsible-content">
      <TableShimmer rowCount={count} />
    </div>
  </div>
);

// Shimmer for market/financial data card
export const MarketDataShimmer = () => (
  <div className="market-data-card real-data">
    <div className="market-data-header">
      <h3 className="market-data-title"><i className="fi fi-rr-chart-histogram"></i> נתוני שוק ומחירים</h3>
    </div>
    <div className="market-data-header">
      <ShimmerBox width="220px" height="24px" />
      <ShimmerBox width="24px" height="24px" borderRadius="50%" />
    </div>
    <div className="market-data-content">
      <div style={{ marginBottom: '16px' }}>
        <ShimmerBox width="60%" height="16px" style={{ marginBottom: '8px' }} />
        <ShimmerBox width="85%" height="14px" style={{ marginBottom: '6px' }} />
        <ShimmerBox width="70%" height="14px" />
      </div>
      <div style={{ display: 'grid', gap: '10px' }}>
        <ShimmerBox width="100%" height="18px" />
        <ShimmerBox width="90%" height="18px" />
        <ShimmerBox width="75%" height="18px" />
      </div>
    </div>
  </div>
);

// Generic plans shimmer (kept for backward compatibility)
export const PlansShimmer = ({ count = 3 }) => (
  <MunicipalSectionShimmer count={count} />
);

// Shimmer for the entire results page - matches new section order
export const ResultsPageShimmer = () => (
  <div className="results-container">
    <PropertyInfoShimmer />
    {/* Permits Card */}
    <div className="market-data-card real-data">
      <div className="market-data-header">
        <h3 className="market-data-title"><i className="fi fi-rr-bank"></i> בקשות והיתרים</h3>
      </div>
      <div className="market-data-content plans-content">
        <TelAvivShimmer count={1} />
      </div>
    </div>

    {/* Plans Card */}
    <div className="market-data-card real-data">
      <div className="market-data-header">
        <h3 className="market-data-title"><i className="fi fi-rr-document"></i> תוכניות</h3>
      </div>
      <div className="market-data-content plans-content">
        <MunicipalSectionShimmer count={3} />
        <MunicipalSectionShimmer count={2} />
      </div>
    </div>
    <MarketDataShimmer />
  </div>
);
